import { BYTES_PER_GB, BYTES_PER_MB } from './videos';

export const SERMON_TITLE_MAX_LENGTH = 100;
export const SERMON_SPEAKER_MAX_LENGTH = 100;
export const SERMON_SERIES_MAX_LENGTH = 100;
export const SERMON_DESCRIPTION_MAX_LENGTH = 500;
export const SERMON_FILENAME_MAX_LENGTH = 255;

export const SERMON_THUMBNAIL_MAX_SIZE_MB = 20; // 20MB
export const SERMON_FILE_MAX_SIZE_GB = 20; // 20GB
export const SERMON_THUMBNAIL_MAX_SIZE_BYTES = SERMON_THUMBNAIL_MAX_SIZE_MB * BYTES_PER_MB;
export const SERMON_FILE_MAX_SIZE_BYTES = SERMON_FILE_MAX_SIZE_GB * BYTES_PER_GB;
export const SERMON_THUMBNAIL_MIN_DIMENSION = 1000; // 1000px minimum width and height

/** Scheduled sermons must publish at least this many calendar days out (a ~2-day lead-time buffer). */
export const PUBLISH_DATE_BUFFER_DAYS = 2;

/** Publishing options on the sermon upload form. `now` publishes once processing finishes; `scheduled` publishes on a chosen date; `draft` processes the sermon but holds it as an editable draft (published later from the Manage menu). */
export const PUBLISH_OPTION = {
  NOW: 'now',
  SCHEDULED: 'scheduled',
  DRAFT: 'draft',
} as const;

export type PublishOption = (typeof PUBLISH_OPTION)[keyof typeof PUBLISH_OPTION];
